import React, {useEffect} from 'react'
import './Soe.css'
import Androidscreenshoot from '../images/Soeimages/Androidscreenshoot.png'
import Artboard1 from '../images/Soeimages/Artboard1.png'
import Artboard2 from '../images/Soeimages/Artboard2.png'
import Artboard3 from '../images/Soeimages/Artboard3.png'
import Artboard4 from '../images/Soeimages/Artboard4.png'
import Artboard5 from '../images/Soeimages/Artboard5.png'
import Artboard6 from '../images/Soeimages/Artboard6.png'
import Artboard7 from '../images/Soeimages/Artboard7.png'
import Artboard8 from '../images/Soeimages/Artboard8.png'
import Artboard9 from '../images/Soeimages/Artboard9.png'
import Artboard10 from '../images/Soeimages/Artboard10.png'
import Artboard11 from '../images/Soeimages/Artboard11.png'
import Artboard12 from '../images/Soeimages/Artboard12.png'
import Artboard13 from '../images/Soeimages/Artboard13.png'
import Artboard14 from '../images/Soeimages/Artboard14.png'
import Artboard16 from '../images/Soeimages/Artboard16.png'
import Footer from '../Component/footer'

function Soe() {
    useEffect(() => {
        console.log('hello am here');
        // window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       

        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        <div className="project-details-soe">
        <div className="client-role-soe">
            <h4 className="client-project-soe">CLIENT</h4>
            <h2 className="portfolio-heading-soe1"> School Of Experience</h2>
            <h4 className="role-soe">
            ROLE
            </h4>
            <h2 className="portfolio-role-soe2">Brand Identity Developer</h2>
           </div>
            <h4 className="client-details-soe"> DETAILS
            </h4>
            <p className="client-details-soe-p">
            At Bosworth Marketing Consulting, we believe in the Acre
       of Diamonds’ Principle; that the solution we seek most is
        much closer than the problem; if only we looked at things
                 differently. We believe the dearth of employable
                       manpower problem can be resolved by equipping the
                  teachable but unemployed people with project
                      management, budget planning, report writing and
                  strategic thinking skills through the free S.O.E
                     © hands-on
                     training program.
            </p>

            <p className="client-details-soe-p2">
            We are committed to contributing skilled and reliable
               manpower that reinforces the growth of the marketing
              services industry in Nigeria
            </p>
         </div>


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard8} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard11} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard12} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard13} height="auto" width="100%" alt=""/></div>
        
         
          <div className="imagevh" id="artboard"><img src={Artboard14} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard16} height="auto" width="100%" alt=""/></div>
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}

export default Soe
